import { type Components, type CssVarsTheme, alpha } from '@mui/material/styles';

import CyanBlur from '../../../assets/images/cyan-blur.png';
import RedBlur from '../../../assets/images/red-blur.png';

export const MuiDrawer: Components<CssVarsTheme>['MuiDrawer'] = {
  styleOverrides: {
    paper: ({ theme, ownerState: { variant } }) => {
      return {
        boxShadow: theme.vars.customShadows.nav,
        backdropFilter: 'blur(20px)',
        backgroundImage: variant === 'temporary' ? `url(${CyanBlur}), url(${RedBlur})` : '',
        backgroundSize: '50% 50%',
        backgroundRepeat: 'no-repeat no-repeat',
        backgroundPosition: 'right top, left bottom',
        minWidth: 200
      };
    }
  }
};

export const MuiBackdrop = {
  styleOverrides: {
    root: ({ theme }: { theme: CssVarsTheme }) => ({
      backgroundColor: alpha(theme.palette.grey[900], 0.8)
    }),
    invisible: {
      background: 'transparent'
    }
  }
};
